// Simulador de integración Stripe en flujo real de inscripción
import React, { useState, useEffect } from "react";

function SimuladorStripePago({ nombreComercio, email, onPagoCompletado }) {
  const [estado, setEstado] = useState("pendiente");

  useEffect(() => {
    // Revisar si el pago ya fue simulado (persistido en localStorage)
    const clavePago = `pago_comerciante_${nombreComercio}_${email}`;
    const yaPagado = localStorage.getItem(clavePago);
    if (yaPagado === "1") {
      setEstado("pagado");
    }
  }, [nombreComercio, email]);

  const simularPago = async () => {
    setEstado("procesando");
    setTimeout(async () => {
      setEstado("pagado");

      // Guardar en localStorage para persistencia en frontend
      const clavePago = `pago_comerciante_${nombreComercio}_${email}`;
      localStorage.setItem(clavePago, "1");

      // Llamar función de notificación (al panel de administrador)
      try {
        const res = await fetch("https://panelcomerciantes.lagora.chat/api/marcar_pago_simulado.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ nombre_comercio: nombreComercio, email })
        });

        const data = await res.json();
        if (data.success && onPagoCompletado) {
          onPagoCompletado();
        }
      } catch (err) {
        console.error("❌ Error notificando pago simulado:", err);
      }
    }, 2000); // Simula retardo de pago
  };

  return (
    <div
      style={{
        border: "1px solid #ccc",
        padding: "1rem",
        borderRadius: "8px",
        maxWidth: "400px",
        margin: "auto",
        backgroundColor: estado === "pagado" ? "#e6fff1" : "#fff",
      }}
    >
      <h3>💳 Simulador de Pago con Stripe</h3>
      <p><strong>Comercio:</strong> {nombreComercio}</p>
      <p><strong>Email:</strong> {email}</p>

      {estado === "pendiente" && (
        <>
          <p>Este comercio aún no ha completado el pago mensual.</p>
          <button onClick={simularPago}>Simular pago</button>
        </>
      )}

      {estado === "procesando" && <p>⏳ Procesando pago...</p>}

      {estado === "pagado" && (
        <p style={{ color: "green" }}>✅ Pago completado correctamente.</p>
      )}
    </div>
  );
}

export default SimuladorStripePago;

